<template>
  <div class="flex items-baseline">
    <div class="flex-1 px-4">
      <RouterLink
        :to="{
          name: 'accounts.pipelines.pipelineUuid',
          params: {
            ...$route.params,
            pipelineUuid: pipeline.id,
          },
        }"
      >
        {{ pipeline.name }}
      </RouterLink>
    </div>
    <div class="px-4">
      <VDropdown v-if="$membershipHasPermissionTo('edit pipelines,delete pipelines')" right>
        <template #button="dropdownProps">
          <button class="btn btn-ghost px-3" @click="dropdownProps.open">
            <FontAwesomeIcon icon="ellipsis-v" fixed-width />
          </button>
        </template>

        <template #default="dropdownProps">
          <VDropdownMenu>
            <a
              v-if="$membershipHasPermissionTo('edit pipelines')"
              role="button"
              :class="[
                'block',
                'px-4',
                'py-2',
                'hover:bg-gray-200',
                'transition-color',
                'transition-fast',
                'text-right',
              ]"
              @click="dropdownProps.close(() => $emit('pipeline-edit', pipeline))"
              >Edit</a
            >
            <a
              v-if="$membershipHasPermissionTo('delete pipelines')"
              role="button"
              :class="[
                'block',
                'px-4',
                'py-2',
                'hover:bg-gray-200',
                'transition-color',
                'transition-fast',
                'text-right',
              ]"
              @click="dropdownProps.close(() => $emit('pipeline-delete', pipeline))"
              >Remove</a
            >
          </VDropdownMenu>
        </template>
      </VDropdown>
    </div>
  </div>
</template>

<script>
import VDropdown from '@/components/Common/VDropdown.vue';
import VDropdownMenu from '@/components/Common/VDropdownMenu.vue';

export default {
  components: {
    VDropdown,
    VDropdownMenu,
  },

  props: {
    pipeline: { type: Object, required: true },
  },
};
</script>
